// extracted by mini-css-extract-plugin
export var grid = "ImageMediaGrid-module--grid--2aKXu";